import { Sticky, StickyContainer } from 'react-sticky'

import React from 'react'
import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'
import {
  BlogGrid,
  BlogMain,
  BlogPageTitle,
  BlogSection,
  CardPost,
  CardPostFeatured,
  FavPostsAside,
  FreeTrial,
  HeaderShadow,
  ListCtaBlock,
  Pager,
  Layout,
  TagsFilter,
} from '../../index'

import { getCtaCode } from './utils'
import { getTranslations } from '../../../utils/context'

const Posts = ({
  data: {
    allHubspotPost: { edges: posts },
    lastpost: { edges: lastPost },
    favoritesposts: { edges: favoritesPosts },
  },
  pageContext: {
    blogPath,
    hrefLangs,
    meta,
    hubspotNewsletter,
    hubspotCta,
    favoritesSlugsObfuscation,
    fixedCategories,
    previousPagePath,
    nextPagePath,
    pageNumber,
    numberOfPages,
    pathPrefix,
    favoritesSlugs,
    ...context
  },
  components: { Newsletter },
  title,
}) => {
  const translations = getTranslations()

  return (
    <Layout
      hreflangs={hrefLangs}
      headerBackgroundColor="white"
      header="BLOG"
      homePath={blogPath}
      isBlog={true}
      meta={meta}
    >
      <style>{`body { background: white !important; }`}</style>
      <HeaderShadow />
      <BlogSection paddingBottom="0">
        {lastPost?.length && (
          <CardPostFeatured blogPath={blogPath} post={lastPost[0].node} />
        )}
        <TagsFilter
          blogPath={blogPath}
          topics={fixedCategories}
          translations={translations}
        />
      </BlogSection>
      <BlogSection paddingBottom="200px">
        <BlogPageTitle>{title || context.title}</BlogPageTitle>
        <BlogGrid>
          <BlogMain>
            {posts &&
              posts.map((post, i) => {
                post.node.slug = `${post.node.slug}`
                return (
                  <CardPost
                    key={i}
                    post={post.node}
                    blogPath={blogPath}
                    translations={translations}
                  />
                )
              })}
            <Pager
              pageContext={{
                previousPagePath,
                nextPagePath,
                pageNumber,
                numberOfPages,
                pathPrefix,
              }}
              translations={translations}
            />
          </BlogMain>
          <ListCtaBlock>
            <Newsletter
              hubspotId={hubspotNewsletter.id}
              hubspotCode={hubspotNewsletter.code}
              buttonHref={hubspotNewsletter.href}
              title={hubspotNewsletter.title}
              subtitle={hubspotNewsletter.subtitle}
              translations={translations}
            />
            {favoritesPosts && (
              <FavPostsAside
                blogPath={blogPath}
                favoritesPosts={favoritesPosts}
                favoritesSlugs={favoritesSlugs}
                favoritesSlugsObfuscation={favoritesSlugsObfuscation}
                favoritesTitle={translations.favorites}
              />
            )}
            <StickyContainer
              style={{ height: 'calc(100% - 1135px)', width: '96%' }}
            >
              <Sticky topOffset={-60}>
                {({ style, isSticky }) => (
                  <div
                    style={{ ...style, marginTop: isSticky ? '100px' : '0px' }}
                  >
                    <FreeTrial cardtitle={translations.post.sidebarCtaTitle}>
                      <ReactMarkdown rehypePlugins={[rehypeRaw]}>
                        {getCtaCode(hubspotCta.code, hubspotCta.uuid)}
                      </ReactMarkdown>
                    </FreeTrial>
                  </div>
                )}
              </Sticky>
            </StickyContainer>
          </ListCtaBlock>
        </BlogGrid>
        <Newsletter
          hubspotId={hubspotNewsletter.id}
          hubspotCode={hubspotNewsletter.code}
          mobile
          buttonHref={hubspotNewsletter.href}
          title={hubspotNewsletter.title}
          subtitle={hubspotNewsletter.subtitle}
          translations={translations}
        />
      </BlogSection>
    </Layout>
  )
}
export default Posts
